import { DataGridRow } from "../Helpers/SharedClasses";
import { LabelModel } from "./LabelModel";


export class StudyModel extends DataGridRow
{
    
    name: string = "";
    description: string = "";
    id?: string = "";
    idFieldForStudy?: string = "None";
    allowPersonalData?: boolean = true;
    allowFullDateOnly?: boolean = false;
    curveEvalEnabled?: boolean = true;
    exportEnabled?: boolean = false; 
    encryptionEnabled?: boolean = false;
    startdate?: Date = undefined;
    expectedProcedures?: number = 0;
    expectedHospitals?: number = 0;
    protocolSteps?: string[] = [];
    workflowFilename?: string = "";
    lowerReferenceValue?: number = 0;
    upperReferenceValue?: number = 0;
    labelTypes?: string[] = [];
    suggestedLabels? : LabelModel[] = [];
    procedures?: number = 0;
    measurements?: number = 0;
    flowNum?: number = 0;
    imagingNum?: number = 0;
    ecgNum?: number = 0;
    noLabelNum?: number = 0;
    lastUpdated?: Date = undefined;
    studyType?: string = "";
    defaultView?: string = "";
    includeSurgeon?: boolean = false;
    includeProject?: boolean = false;
    calculateBMI?: boolean = false;
    meanGoodColor?: string = "";
    meanBadColor?: string = "";
    meanWorstColor?: string = "";
    aciLowerReferenceValue?: number = 0;
    aciUpperReferenceValue?: number = 0;
    aciGoodColor?: string = "";
    aciBadColor?: string = "";
    aciWorstColor?: string = "";
    piLowerReferenceValue?: number = 0;
    piUpperReferenceValue?: number = 0;
    piGoodColor?: string = "";
    piBadColor?: string = "";
    piWorstColor?: string = "";
    bfLowerReferenceValue?: number = 0;
    bfUpperReferenceValue?: number = 0;
    bfGoodColor?: string = ""; 
    bfBadColor?: string = "";
    bfWorstColor?: string = "";
    dfLowerReferenceValue?: number = 0;
    dfUpperReferenceValue?: number = 0;
    dfGoodColor?: string = ""; 
    dfBadColor?: string = "";
    dfWorstColor?: string = "";
}